export default __webpack_public_path__ + "static/media/reviewsHero.f0776313.jpg";